import { transferCruise } from '@/_config/transfer';
import { flattenTransferOffers } from '../../utils';
import { convertPrice } from '@/_helper/mapper';
import type { CruiseOffers, TransferOffer, TransferTypeConfig } from '@/model/upsell/transfer';

import './offer-cards.scss';

function lookupTransferConfig(tariffCode: string): TransferTypeConfig {
    const key = tariffCode.toLowerCase();
    return Object.entries(transferCruise).find(([k]) => k === key)?.[1] ?? transferCruise.shuttle;
}

interface CardProps {
    transferOffer: TransferOffer;
    selectedOffer: string | null;
    onSelection: (offerKey: string) => void;
}

const Card = ({ transferOffer, selectedOffer, onSelection }: CardProps) => {
    const { price, offerKey, tariffCode } = transferOffer;
    const { label, features, descriptions } = lookupTransferConfig(tariffCode);

    return (
        <div
            className={`offer-card ${selectedOffer === offerKey ? 'selected' : ''}`}
            onClick={() => onSelection(offerKey)}>
            <div className="card-header">
                <div className="label">{label}</div>
                <div className="price-container">
                    <div className="price-value">{convertPrice(price.overallGrossPrice, 0, 0)}</div>
                    <div className="price-label">Gesamtpreis</div>
                </div>
            </div>

            {features && (
                <ul className="features">
                    {features?.map((feature: string, i: number) => (
                        <li key={i}>
                            <span className="material-symbols-outlined icon">check</span>
                            {feature}
                        </li>
                    ))}
                </ul>
            )}

            {descriptions && (
                <div className="description-container">
                    {descriptions?.map((description: string, i: number) => (
                        <p className="description" key={i}>
                            {description}
                        </p>
                    ))}
                </div>
            )}
        </div>
    );
};

interface OfferCardsProps {
    cruiseOffers: CruiseOffers;
    selectedOffer: string | null;
    onSelection: (offerKey: string) => void;
}

const OfferCards = ({ cruiseOffers, selectedOffer, onSelection }: OfferCardsProps) => {
    const transferOffers = flattenTransferOffers(cruiseOffers);

    return (
        <div className="offer-cards-container">
            {Object.values(transferOffers).map((transferOffer) => (
                <Card
                    key={transferOffer.offerKey}
                    transferOffer={transferOffer}
                    selectedOffer={selectedOffer}
                    onSelection={onSelection}
                />
            ))}
        </div>
    );
};

export default OfferCards;
